import { combineReducers } from "redux";
import { restaurantsReducer } from "./restaurantsReducer";
import { bakeryReducer } from "./bakeryReducer";
import { restaurantsDetailReducer } from "./restaurantsDetailsReducer";
import { cartReducer } from "./cartsReducer";
import { darkModeReducer } from "./darkModeReducer";

export const rootReducer = combineReducers({
    restaurantsReducer: restaurantsReducer,
    bakeryReducer: bakeryReducer,
    restaurantsDetailReducer: restaurantsDetailReducer,
    cartReducer: cartReducer,
    darkModeReducer: darkModeReducer
})